import { jwtDecode } from 'jwt-decode';

/**
 * Decode a JWT token and extract guest information
 * @param {string} token - The JWT token to decode
 * @returns {Object} Decoded token information
 */
export const decodeGuestToken = (token) => {
  try {
    const decodedToken = jwtDecode(token);
    return {
      success: true,
      decodedToken,
      userData: decodedToken.userData || {},
      instanceId: decodedToken.userData?.instance_id,
      singleUserEmail: decodedToken.userData?.single_user_email
    };
  } catch (error) {
    console.error('Error decoding guest token:', error);
    return {
      success: false,
      error: error.message
    };
  }
};

/**
 * Validate guest token structure
 * @param {Object} decodedToken - The decoded token object
 * @returns {Object} Validation result
 */
export const validateGuestToken = (decodedToken) => {
  const requiredFields = ['userData', 'instance_id'];
  const missingFields = requiredFields.filter(field => {
    if (field === 'instance_id') {
      return !decodedToken.userData?.instance_id;
    }
    return !decodedToken[field];
  });

  if (missingFields.length > 0) {
    return {
      isValid: false,
      missingFields,
      message: `Missing required fields: ${missingFields.join(', ')}`
    };
  }

  return {
    isValid: true,
    message: 'Token is valid'
  };
};

/**
 * Extract guest information from token
 * @param {string} token - The JWT token
 * @returns {Object} Guest information
 */
export const extractGuestInfo = (token) => {
  const decodeResult = decodeGuestToken(token);
  
  if (!decodeResult.success) {
    return {
      success: false,
      error: decodeResult.error
    };
  }

  const validationResult = validateGuestToken(decodeResult.decodedToken);
  
  if (!validationResult.isValid) {
    return {
      success: false,
      error: validationResult.message
    };
  }

  return {
    success: true,
    instanceId: decodeResult.instanceId,
    singleUserEmail: decodeResult.singleUserEmail,
    userData: decodeResult.userData,
    decodedToken: decodeResult.decodedToken
  };
};
